import Markdown from 'markdown-to-jsx'
import dynamic from 'next/dynamic'
import React, { useEffect, useState } from 'react'

import { getTranslate } from '@/legacy-src/utilities/i18n'

import animationData from '../animations/breathAnimation.json'

const Lottie = dynamic(() => import('react-lottie'), { ssr: false })

const BubbleAnimation = () => {
  const { t } = getTranslate()
  const [isBreathing, setIsBreathing] = useState(true)

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  useEffect(() => {
    const handler = setInterval(() => {
      setIsBreathing((prevState) => !prevState)
    }, 2400)

    return () => {
      clearInterval(handler)
    }
  }, [])

  return (
    <div className="flex max-h-[100vh] w-full flex-col items-center">
      <h2 className="relative z-10 mb-20 mt-10 animate-fade-in text-center text-secondary opacity-0 animation-delay-300 tablet:mt-10 desktop:mt-20">
        <Markdown>{t(`diagnosisTest.diagnosisV3.bestTherapist.titlePersonalised`)}</Markdown>
      </h2>
      <div>
        <div className="hidden max-h-full desktop:block">
          <Lottie options={defaultOptions} width={500} />
        </div>

        <div className="flex max-h-full desktop:hidden">
          <Lottie options={defaultOptions} width={400} />
        </div>

        <h3 className="-mt-[60px] text-center text-secondary tablet:-mt-[70px]">
          <div className={`animate-fade-in opacity-0 animation-delay-200 ${isBreathing ? '' : 'hidden'}`}>
            <Markdown>{t(`diagnosisTest.diagnosisV3.bestTherapist.breathIn`)}</Markdown>
          </div>

          <div className={`animate-fade-in opacity-0 animation-delay-200 ${isBreathing ? 'hidden' : ''}`}>
            <Markdown>{t(`diagnosisTest.diagnosisV3.bestTherapist.breathOut`)}</Markdown>
          </div>
        </h3>
      </div>
    </div>
  )
}

export default BubbleAnimation
